import { Component, OnInit } from "@angular/core";
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from "@angular/router";
import { FacturasIAService } from "../../../services/ia/facturasia.service";
import { ReconocimientoFacturaDTO } from "../../../models/ia/facturas";
import { ContactosService } from "../../../services/employees/contactos.service";
import { ContactDTO, ContactModel } from "../../contact/contact/contact.model";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { PAY_METHODS } from "../../../consts";
import { EfectivoService } from "../../../services/finanzas/efectivo/efectivo.service";
import { Efectivo } from "../../../models/finanzas/efectivo/efectivo.model";
import { BankAccountModel } from "../../finanzas/bancos/bankaccount.model";
import { BankAccountService } from "../../finanzas/bancos/bankaccount.service";
import { PaymentCardModel } from "../../finanzas/paymentcard/paymentcard.model";
import { PaymentCardService } from "../../finanzas/paymentcard/paymentcard.service";
import { SubscriptionsService } from "../../../services/subscriptions/subscriptions.service";
import { DialogsService } from "../../../shared/components/dialogs/dialogs.service";
import { ContactFormV2Component } from '../../../modules_v2/contacts/components/contact-form-v2/contact-form-v2.component';
import { map } from 'rxjs/operators';

@Component({
    selector: "app-gastos-ia",
    templateUrl: "./ia.component.html",
    styleUrls: ["./ia.component.css"],
    standalone: false
})
export class IAGastosComponent implements OnInit {

  // #region Propiedades del componente
  displayedColumns: string[] = ['acciones', 'nombreFichero', 'type', 'cadenaFecha', 'error'];
  displayedColumnsContabilizadas: string[] = ['acciones', 'nombreFichero', 'type', 'cadenaFechaProcesado'];

  bankAccounts: BankAccountModel[] = [];
  contactoReconocido: ContactDTO = null;
  efectivoList: Efectivo[] = [];
  facturaReconocida: ReconocimientoFacturaDTO = null;
  formContacto!: UntypedFormGroup;
  formRelacionTipoPago!: UntypedFormGroup;
  payMethod = PAY_METHODS;
  paymentCards: PaymentCardModel[] = [];
  // #endregion

  constructor(
    private router: Router,
    public dialog: MatDialog,
    protected snackBar: MatSnackBar,
    private bankAccountService: BankAccountService,
    public contactosService: ContactosService,
    private dialogService: DialogsService,
    private efectivoService: EfectivoService,
    public facturasIAService: FacturasIAService,
    private paymentCardService: PaymentCardService,
    public subscriptionService: SubscriptionsService
  ) {
  }

  ngOnInit(): void {

    // Comprobación de la suscripción de IA
    this.subscriptionService.checkSubscriptionIA().subscribe({
      next: (resultado: boolean) => {
        console.log('Resultado de la comprobación de la suscripción de IA.', resultado);
        if (!resultado) {
          this.router.navigate(['/subscription']);
        }
        else {
          this.facturasIAService.obtencionListaSinContabilizar();
          this.facturasIAService.obtencionListaContabilizadas();

          // Obtención de las facturas sin contabilizar y contabilizadas
          this.inicializarFormContacto(null);
          this.inicializarFormRelacionTipoPago();

          // Obtención de la lista de los contactos
          this.contactosService.listaProveedoresDTO();

          // // Cuentas bancarias
          // this.bankAccountService.getList().then(
          //   bankAccounts => {
          //     this.bankAccounts = bankAccounts.list;
          //   });

          // // Tipos de efectivos.
          // this.efectivoService.list()
          //   .then(response => this.efectivoList = response);

          // // Tarjetas de crédito
          // this.paymentCardService.getList(0).then(
          //   paymentCards => {
          //     this.paymentCards = paymentCards.list;
          //   });
        }
      }
    });
  }

  // #region Métodos del componente

  actualizarContacto(): void {
    if (this.formContacto.valid) {
      this.facturasIAService.actualizarProveedor(this.facturaReconocida.uidFichero, this.formContacto.value.contacto.id)
        .subscribe({
          next: (resultado: ReconocimientoFacturaDTO | null) => {
            if (resultado != null) {
              this.cancelar();
            }
          }
        });
    }
  }

  /**
   * Cancela la factura seleccionada
   */
  cancelar(): void {
    this.contactoReconocido = null;
    this.facturaReconocida = null;
  }

  /**
   * Se selecciona una factura para comprobar sus datos y para realizar las operaciones disponibles.
   * @param factura Datos de la factura seleccionada
   */
  editar(factura: ReconocimientoFacturaDTO): void {
    this.facturaReconocida = factura;

    // Obtención del proveedor asociado a la factura
    if (this.facturaReconocida.contactId != null && this.facturaReconocida.contactId > 0) {
      this.contactoReconocido = this.contactosService.obtenerProveedorDTOPorId(this.facturaReconocida.contactId);
    } else {
      this.contactoReconocido = null;
      this.inicializarFormContacto(this.contactoReconocido);
    }

    // Se comprueba el tipo de error que se ha producido en la conversión de la factura
    if (this.facturaReconocida.error.trim() != '') {
      if (this.contactoReconocido != null && this.facturaReconocida.error == this.facturasIAService._ERROR_NO_RELATION_TYPEPAID) {
        this.inicializarFormRelacionTipoPago();
      }
    }
  }

  /**
   * Intenta regenar la factura seleccionada.
   */
  intentarRegenerarFactura(): void {
    if (this.facturaReconocida != null) {
      this.facturasIAService.regenerarFactura(this.facturaReconocida.uidFichero)
        .subscribe({
          next: (resultado: boolean) => {
            if (resultado) {
              this.cancelar();
            }
          }
        });
    }
  }

  /**
   * Marca la factura como eliminada.
   * @param factura Datos de la factura seleccionada
   */
  marcarComoEliminada(factura: ReconocimientoFacturaDTO): void {
    this.dialogService.confirm('Eliminar factura', '¿Estás seguro de que deseas eliminar la factura de la lista de reconocimiento por IA?')
      .subscribe({
        next: (resultado: boolean) => {
          if (resultado) {
            this.facturasIAService.marcarComoEliminada(factura.uidFichero)
              .subscribe({
                next: (resultado: boolean) => {
                  if (resultado) {
                    this.cancelar();
                  }
                }
              });
          }
        }
      });
  }

  /**
   * Crea un nuevo contacto para asociarlo a la factura seleccionada.
   */
  nuevoContacto(): void {
    const contact = new ContactModel();

    contact.isProvider = true;
    contact.isClient = false;
    contact.isPhysical = true;

    const dialogNewContact = ContactFormV2Component.open(this.dialog, { scratch: contact });

    dialogNewContact
      .subscribe((result) => {
        if (!result) return;
        this.contactosService.listaProveedoresDTO();

        this.snackBar.open(
          'Se ha creado el contacto correctamente. Ya lo tiene disponible como Emisor de la factura.',
          'Cerrar',
          {
            duration: 3000,
          }
        );
      });
  }

  // #endregion

  // #region Propiedades privadas

  private inicializarFormContacto(contacto: ContactDTO | null): void {
    this.formContacto = new UntypedFormGroup({
      contacto: new UntypedFormControl(contacto)
    });
  }

  private inicializarFormRelacionTipoPago(): void {
    this.formRelacionTipoPago = new UntypedFormGroup({
      tipoPago: new UntypedFormControl(null),
      efectivoId: new UntypedFormControl(null),
      typePayBankAccount: new UntypedFormControl(null),
    });
  }

  // #endregion
  public trackByIndex(i: number) { return i; }

}
